import { render, staticRenderFns } from "./activityManage.vue?vue&type=template&id=688c7878&"
import script from "./activityManage.vue?vue&type=script&lang=js&"
export * from "./activityManage.vue?vue&type=script&lang=js&"
import style0 from "./activityManage.vue?vue&type=style&index=0&id=688c7878&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports